import { render, staticRenderFns } from "./ContractAttachmentsList.vue?vue&type=template&id=8c0856de&"
import script from "./ContractAttachmentsList.vue?vue&type=script&lang=ts&"
export * from "./ContractAttachmentsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports